module.exports = __webpack_public_path__ + "ic-delete-blue.svg?c5033093678c0bf969463d0de7d3e295";